import PrimaryButton from "components/buttons/primary-button";
import TextInput from "components/inputs/text-input";
import Modal from "components/modal";
import ModalTemplate from "components/modal/modal-template";
import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ITrack, ITrackSplit } from "types/musicData";
import AddPersonModal from "./components/add-person-modal";
import { FindArtisByName } from "services/user/getUser";

interface IProps {
  trackList: ITrack[];
  setTrackSplit: (split: ITrackSplit[], index: number) => void;
}
const StepThree = ({ trackList, setTrackSplit }: IProps) => {
  const [editMode, setEditMode] = useState(false);
  const [trackIndex, setTrackIndex] = useState(0);
  const [activeTrack, setActiveTrack] = useState(trackList[trackIndex]);
  const [modalOpen, setModalOpen] = useState(false);
  const IconColors = [Colors.purple200, Colors.yellow300, Colors.success];

  const [splitArtists, setSplitArtists] = useState<ITrackSplit[]>(
    trackList[0].split || []
  );

  const totalSplit = splitArtists.reduce((total, item, i) => {
    return total + item.percentage;
  }, 0);

  const handlePercentChange = (index: number, value: string) => {
    //total split except that certain index
    const totalSplitExcludeIndex = splitArtists.reduce((total, item, i) => {
      return i !== index ? total + item.percentage : total;
    }, 0);

    if (Number(value) > 100 - totalSplitExcludeIndex) {
      return;
    }
    const splits = [...splitArtists];
    splits[index] = { ...splits[index], percentage: Number(value) };

    setSplitArtists([...splits]);
  };

  const SaveSplits = () => {
    setTrackSplit(splitArtists, trackIndex);
    setEditMode(false);
  };

  const OnAddPerson = (name: string, email: string) => {
    setSplitArtists((prev) => [
      ...prev,
      { recipientName: name, recipientEmail: email, percentage: 0 }
    ]);
  };

  const OnRemovePerson = (index: number) => {
    setSplitArtists((prev) => prev.filter((_, i) => i !== index));
  };

  const GetRandomColor = (index: number) => {
    const min = Math.ceil(0);
    const max = Math.floor(IconColors.length - 1);

    const rand = Math.floor(Math.random() * (max - min + 1)) + min;

    return IconColors[index] ? IconColors[index] : IconColors[rand];
  };

  //setSplitArtists on Load if empty
  useEffect(() => {
    if (trackList[0].trackArtists && !trackList[0].split) {
      const { name } = trackList[0]?.trackArtists[0];
      const email = FindArtisByName(name)?.email;

      setSplitArtists([
        {
          recipientName: name,
          recipientEmail: email || "",
          percentage: 100
        }
      ]);
    }
  }, []);

  useEffect(() => {
    setActiveTrack(trackList[trackIndex]);
    const track = trackList[trackIndex];
    // setEditMode(false);

    //if there's saved data in the split
    if (track.split?.length && track.split) {
      setSplitArtists(track.split || []);
    }

    // if split is empty
    if (track.trackArtists && !track.split) {
      const { name } = track?.trackArtists[0];
      const email = FindArtisByName(name)?.email;
      setSplitArtists([
        { recipientName: name, recipientEmail: email || "", percentage: 100 }
      ]);
      // if (splitArtists[0].recipientName) {
      //   SaveSplits();
      // }
    }
  }, [trackIndex, trackList]);

  return (
    <Container>
      <LeftDiv>
        <SplitContainer>
          <TitleContainer>
            <Typography
              mb="1.6"
              weight="medium"
              size="2xl"
              color={Colors.white300}
            >
              Splits
            </Typography>
          </TitleContainer>
          <SplitBody>
            <ArtistItem>
              <ArtistName>
                <ArtistIcon style={{ backgroundColor: GetRandomColor(0) }}>
                  <Typography size="s" color={Colors.white200}>
                    {splitArtists[0]?.recipientName[0]}
                  </Typography>
                </ArtistIcon>
                <Typography size="s" color={Colors.white300}>
                  {splitArtists[0]?.recipientName}
                </Typography>
              </ArtistName>
              <InputItem>
                <TextInput
                  type="number"
                  min={0}
                  disabled={!editMode}
                  lockIcon={false}
                  value={splitArtists[0]?.percentage}
                  onChange={(e) => {
                    handlePercentChange(0, e.target.value);
                  }}
                  padding="0.4rem"
                />
                <Typography ml="0.4">%</Typography>
              </InputItem>
            </ArtistItem>
            {editMode && <HL />}
            {splitArtists?.map(
              (
                {
                  recipientName: name,
                  percentage: split,
                  recipientEmail: email
                },
                i
              ) => {
                if (i === 0) {
                  return null;
                }
                return (
                  <ArtistItem key={i}>
                    <ArtistName>
                      <ArtistIcon
                        style={{ backgroundColor: GetRandomColor(i) }}
                      >
                        <Typography size="s" color={Colors.white200}>
                          {name[0]}
                        </Typography>
                      </ArtistIcon>
                      <Typography size="s" color={Colors.white300}>
                        {name}
                      </Typography>
                    </ArtistName>
                    {email && (
                      <Typography size="s" color={Colors.grey500}>
                        ({email})
                      </Typography>
                    )}
                    <ArtistRighSides>
                      <InputItem>
                        <TextInput
                          type="number"
                          min={0}
                          disabled={!editMode}
                          lockIcon={false}
                          value={split}
                          onChange={(e) => {
                            handlePercentChange(i, e.target.value);
                          }}
                          padding="0.4rem"
                        />
                        <Typography ml="0.4">%</Typography>
                      </InputItem>
                      {editMode && (
                        <RemovePersonIcon onClick={() => OnRemovePerson(i)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="100%"
                            height="100%"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M18.3346 10.0003C18.3346 14.6027 14.6036 18.3337 10.0013 18.3337C5.39893 18.3337 1.66797 14.6027 1.66797 10.0003C1.66797 5.39795 5.39893 1.66699 10.0013 1.66699C14.6036 1.66699 18.3346 5.39795 18.3346 10.0003ZM13.1263 10.0003C13.1263 10.3455 12.8465 10.6253 12.5013 10.6253H7.5013C7.15613 10.6253 6.8763 10.3455 6.8763 10.0003C6.8763 9.65516 7.15613 9.37533 7.5013 9.37533H12.5013C12.8465 9.37533 13.1263 9.65516 13.1263 10.0003Z"
                              fill="#FEB73D"
                            />
                          </svg>
                        </RemovePersonIcon>
                      )}
                    </ArtistRighSides>
                  </ArtistItem>
                );
              }
            )}

            {editMode && (
              <AddPersonContainer onClick={() => setModalOpen(true)}>
                <AddIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M7.0013 12.8332C10.223 12.8332 12.8346 10.2215 12.8346 6.99984C12.8346 3.77818 10.223 1.1665 7.0013 1.1665C3.77964 1.1665 1.16797 3.77818 1.16797 6.99984C1.16797 10.2215 3.77964 12.8332 7.0013 12.8332Z"
                      stroke="#FEB73D"
                      stroke-width="0.875"
                    />
                    <path
                      d="M8.75 7H7M7 7H5.25M7 7V5.25M7 7V8.75"
                      stroke="#FEB73D"
                      stroke-width="0.875"
                      stroke-linecap="round"
                    />
                  </svg>
                </AddIcon>
                <Typography color={Colors.yellow400} ml="0.8">
                  Add Person
                </Typography>
              </AddPersonContainer>
            )}
          </SplitBody>
        </SplitContainer>
        <TotalContainer>
          <TotalIcon>
            {totalSplit < 100 ? (
              <svg
                fill="#ff0000"
                height="100%"
                width="100%"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 300.003 300.003"
                xmlSpace="preserve"
                stroke="#ff0000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <g>
                    {" "}
                    <g>
                      {" "}
                      <path d="M150,0C67.159,0,0.001,67.159,0.001,150c0,82.838,67.157,150.003,149.997,150.003S300.002,232.838,300.002,150 C300.002,67.159,232.839,0,150,0z M206.584,207.171c-5.989,5.984-15.691,5.984-21.675,0l-34.132-34.132l-35.686,35.686 c-5.986,5.984-15.689,5.984-21.672,0c-5.989-5.991-5.989-15.691,0-21.68l35.683-35.683L95.878,118.14 c-5.984-5.991-5.984-15.691,0-21.678c5.986-5.986,15.691-5.986,21.678,0l33.222,33.222l31.671-31.673 c5.986-5.984,15.694-5.986,21.675,0c5.989,5.991,5.989,15.697,0,21.678l-31.668,31.671l34.13,34.132 C212.57,191.475,212.573,201.183,206.584,207.171z"></path>{" "}
                    </g>{" "}
                  </g>{" "}
                </g>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.6654 8.00016C14.6654 11.682 11.6806 14.6668 7.9987 14.6668C4.3168 14.6668 1.33203 11.682 1.33203 8.00016C1.33203 4.31826 4.3168 1.3335 7.9987 1.3335C11.6806 1.3335 14.6654 4.31826 14.6654 8.00016ZM10.6856 5.97994C10.8808 6.1752 10.8808 6.49179 10.6856 6.68703L7.35223 10.0204C7.15696 10.2156 6.84043 10.2156 6.64514 10.0204L5.31181 8.68703C5.11655 8.49176 5.11655 8.17523 5.31181 7.97996C5.50707 7.7847 5.82366 7.7847 6.01892 7.97996L6.9987 8.9597L8.48856 7.46983L9.9785 5.97994C10.1738 5.78468 10.4903 5.78468 10.6856 5.97994Z"
                  fill="#5AB400"
                />
              </svg>
            )}
          </TotalIcon>
          <Typography color={Colors.white300} ml="0.8">
            Total: {totalSplit}%
          </Typography>
        </TotalContainer>
        <ButtonArea>
          {editMode ? (
            <PrimaryButton
              text="Save splits for this track"
              onClick={SaveSplits}
              disabled={totalSplit < 100}
            />
          ) : (
            <EditButton onClick={() => setEditMode(true)}>
              <EditIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M8.37803 2.37906L8.91866 1.83838C9.81448 0.942546 11.2669 0.942546 12.1628 1.83838C13.0586 2.7342 13.0586 4.18663 12.1628 5.08246L11.6221 5.62313M8.37803 2.37906C8.37803 2.37906 8.44558 3.528 9.45935 4.54178C10.4731 5.55555 11.6221 5.62313 11.6221 5.62313M8.37803 2.37906L3.40728 7.34978C3.0706 7.68648 2.90226 7.85477 2.75749 8.04039C2.58671 8.25937 2.4403 8.49626 2.32083 8.74692C2.21956 8.95943 2.14428 9.1853 1.99371 9.63697L1.35569 11.5511M11.6221 5.62313L6.65136 10.5939C6.31466 10.9305 6.14637 11.0989 5.96075 11.2436C5.74178 11.4144 5.50487 11.5609 5.25421 11.6803C5.04171 11.7816 4.81585 11.8568 4.36416 12.0074L2.45009 12.6455M1.35569 11.5511L1.19973 12.019C1.12564 12.2412 1.18349 12.4863 1.34917 12.652C1.51485 12.8177 1.75992 12.8755 1.98221 12.8014L2.45009 12.6455M1.35569 11.5511L2.45009 12.6455"
                    stroke="#FEB73D"
                    stroke-width="1.02083"
                  />
                </svg>
              </EditIcon>
              <Typography color={Colors.yellow400} ml="0.8">
                Edit splits for this track
              </Typography>
            </EditButton>
          )}
        </ButtonArea>
      </LeftDiv>
      <TracksDiv>
        {trackList.map(({ trackDetails, trackArtists }, i) => {
          const active = trackIndex === i;
          return (
            <TrackItem key={i} onClick={() => setTrackIndex(i)}>
              <TrackNumber active={active ? "true" : "false"}>
                <Typography
                  size="lg"
                  color={active ? Colors.white100 : Colors.grey600}
                >
                  {i + 1}
                </Typography>
              </TrackNumber>
              <TrackTextContainer>
                <Typography mb="0.2" weight="semibold" color="white">
                  {trackDetails?.title}
                </Typography>
                <div style={{ display: "flex" }}>
                  {trackArtists?.map(({ name }, i) => {
                    return (
                      <Typography size="xs" color={Colors.grey500} key={i}>
                        {name} {i !== trackArtists.length - 1 && ", "}
                      </Typography>
                    );
                  })}
                </div>
              </TrackTextContainer>
              {active && <ActiveTrackItem />}
            </TrackItem>
          );
        })}
      </TracksDiv>
      <Modal isActive={modalOpen} closeModal={() => setModalOpen(false)}>
        <AddPersonModal
          split={splitArtists}
          confirm={(name, email) => {
            OnAddPerson(name, email);
          }}
          close={() => setModalOpen(false)}
        />
      </Modal>
    </Container>
  );
};

export default StepThree;

const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  height: 100%;
  @media only screen and (max-width: 769px) {
    flex-direction: column-reverse;
  }
`;

const LeftDiv = styled.div`
  width: 30%;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const SplitContainer = styled.div`
  border-radius: 0.8rem;
  background: ${Colors.grey700};
  padding: 2.4rem;
  margin-bottom: 2.4rem;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: fit-content;
`;

const TitleContainer = styled.div`
  border-bottom: 0.5px solid ${Colors.grey600};
`;

const SplitBody = styled.div`
  width: 100%;
`;

const ArtistItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2.4rem;
`;

const ArtistIcon = styled.div`
  display: flex;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
`;

const ArtistName = styled.div`
  display: flex;
  align-items: center;
`;

const ArtistRighSides = styled.div`
  display: flex;
  align-items: center;
`;
const InputItem = styled.div`
  display: flex;
  align-items: center;
  width: 7rem;
`;

const RemovePersonIcon = styled.div`
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  margin-left: 1rem;
`;

const HL = styled.div`
  margin-top: 1.6rem;
  width: 100%;
  height: 1px;
  border-top: 1px solid ${Colors.grey600};
`;

const TotalContainer = styled.div`
  border-radius: 0.4rem;
  width: 100%;
  padding: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Colors.grey700};
  margin-top: 1.6rem;
`;

const TotalIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
`;

const ButtonArea = styled.div`
  width: 100%;
  margin-top: 2.4rem;
`;

const EditButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const EditIcon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;

const TracksDiv = styled.div`
  width: 27rem;
  background: ${Colors.grey700};
  border-radius: 0.8rem;
  margin-left: 1.6rem;
  height: fit-content;
  padding: 1.6rem 0;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-bottom: 2.4rem;
    margin-left: 0;
  }
`;

const TrackItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.6rem 0;
  padding-left: 1.6rem;
  border-bottom: 0.2px solid ${Colors.grey600};
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:last-child {
    border-bottom: unset;
  }
`;

const TrackNumber = styled.div<{ active: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  background: ${(props) =>
    props.active === "true" ? Colors.grey600 : "transparent"};
  border: ${(props) =>
    props.active === "true" ? undefined : `1px solid ${Colors.grey600}`};

  margin-right: 1.2rem;
`;

const TrackTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ActiveTrackItem = styled.div`
  width: 0.5px;
  border-left: 1px solid ${Colors.yellow500};
  position: absolute;
  right: 0;
  height: 3.8rem;
  transition: all 0.2s ease-in-out;
`;

const AddPersonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 2.4rem;
`;

const AddIcon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;
